import { commonEnvironment } from '~/constants/environment';
import * as home from '../home/experiments';
import * as search from '../search/experiments';
import * as sem from '../sem/experiments';
import * as vdp from '../vdp/experiments';

export const settings = {
  cacheMinutes: 15,
  environment: commonEnvironment
};

export const clientSideBrowserCookieIdExperiments = {
  ...home.clientSideBrowserCookieIdExperiments,
  ...search.clientSideBrowserCookieIdExperiments,
  ...sem.clientSideBrowserCookieIdExperiments,
  ...vdp.clientSideBrowserCookieIdExperiments
};

export const serverSideBrowserCookieIdExperiments = {
  ...home.serverSideBrowserCookieIdExperiments,
  ...search.serverSideBrowserCookieIdExperiments,
  ...sem.serverSideBrowserCookieIdExperiments,
  ...vdp.serverSideBrowserCookieIdExperiments
};

export const clientSideUserIdExperiments = {
  ...home.clientSideUserIdExperiments,
  ...search.clientSideUserIdExperiments,
  ...sem.clientSideUserIdExperiments,
  ...vdp.clientSideUserIdExperiments
};

// NOTE: Not currently wired up in the getExperiments middleware
export const serverSideUserIdExperiments = {
  ...home.serverSideUserIdExperiments,
  ...search.serverSideUserIdExperiments,
  ...sem.serverSideUserIdExperiments,
  ...vdp.serverSideUserIdExperiments
};

export const clientSideExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments
};

export const serverSideExperiments = {
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const browserCookieIdExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...serverSideBrowserCookieIdExperiments
};

export const userIdExperiments = {
  ...clientSideUserIdExperiments,
  ...serverSideUserIdExperiments
};

export const experiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments,
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const experimentNames = Object.keys(experiments);
